const getSocketServerUrl = () => {
  const envBase = process.env.REACT_APP_API_BASE_URL;
  const localWebServer = 'http://localhost:5001';

  let server = envBase;
  if (!server && typeof window !== 'undefined') {
    const currentOrigin = window.location.origin;
    if (currentOrigin === 'https://www.ulcaapp.com') {
      server = 'https://www.ulcaapp.com';
    } else if (currentOrigin === 'https://ulcaapp.testatozas.in') {
      server = 'https://ulcaapp.testatozas.in';
    } else {
      server = localWebServer;
    }
  }

  return process.env.REACT_APP_SERVER_URL || server || localWebServer;
};

export default getSocketServerUrl;
